import { Resizable, ResizeCallback } from "re-resizable";
import React from "react";
import { AlignmentButtons } from "./AlignmentButtons.component";
import { getAligmentClass, updateEditorState } from "./Image.helpers";
import { CustomImage } from "./Image.styles";
import { Alignment, CustomImageProps, IEditorHelpers, IImageData } from "./types";

export const getImageComponent = (helpers: IEditorHelpers): React.FC<CustomImageProps> => ({
  block,
  contentState,
  blockProps: { toggleReadOnly },
}) => {
  const entityKey = block.getEntityAt(0);
  const { alignment, alt, height, width, src } = contentState.getEntity(entityKey).getData() as IImageData;
  const imageAlignmentClass = getAligmentClass(alignment);
  const [showAlignmentButtons, toggleShowAlignmentButtons] = React.useState(false);
  const toggleIsMouseOverEvent = (value: boolean) => () => {
    toggleShowAlignmentButtons(value);
    /**
     * Taken from: https://draftjs.org/docs/advanced-topics-block-components
     * If your custom block renderer requires mouse interaction, it is often
     * wise to temporarily set your Editor to readOnly={true} during this
     * interaction.
     */
    toggleReadOnly(value);
  };
  const updateEditor = updateEditorState(helpers);
  const updateImage = (newAligment: Alignment) => () => {
    const data = { alignment: newAligment };
    updateEditor({ data, entityKey, contentState });
  };
  const updateImageSize: ResizeCallback = (_, dir, ref, d) => {
    const data = {
      height: `${ref.clientHeight - 10}px`,
      width: `${ref.clientWidth - 10}px`,
    };
    updateEditor({
      contentState,
      data,
      entityKey,
    });
  };
  return (
    <span
      className={`rdw-image-alignment ${imageAlignmentClass}`}
      onMouseEnter={toggleIsMouseOverEvent(true)}
      onMouseLeave={toggleIsMouseOverEvent(false)}
    >
      <span className="rdw-image-imagewrapper">
        <Resizable onResizeStop={updateImageSize} lockAspectRatio={true}>
          <CustomImage {...{ showAlignmentButtons, src, alt, style: { height, width } }} />
        </Resizable>
        <AlignmentButtons {...{ showAlignmentButtons, alignImage: updateImage }} />
      </span>
    </span>
  );
};
